import { render } from "./LinkInvoiceToSupplierInvoice.vue?vue&type=template&id=bc86330c"
import script from "./LinkInvoiceToSupplierInvoice.vue?vue&type=script&lang=js"
export * from "./LinkInvoiceToSupplierInvoice.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Amaze-Portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__